/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../common/token';
import '../../common/user_attributes';
import './status';
import '../../common/variable';
const $root = $protobuf.roots['square-experiments'] || ($protobuf.roots['square-experiments'] = new $protobuf.Root());
$root.addJSON({
  "squareup": {
    "nested": {
      "feature": {
        "nested": {
          "relay": {
            "nested": {
              "experiments": {
                "nested": {
                  "message": {
                    "nested": {
                      "GetActivateExperimentRequest": {
                        "fields": {
                          "experimentName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "userToken": {
                            "type": "squareup.feature.relay.common.Token",
                            "id": 2,
                            "rule": "optional"
                          },
                          "userAttributes": {
                            "type": "squareup.feature.relay.common.UserAttributes",
                            "id": 3,
                            "rule": "optional"
                          },
                          "projectId": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "cdpKey": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "GetActivateExperimentResponse": {
                        "fields": {
                          "status": {
                            "type": "squareup.feature.relay.experiments.message.Status",
                            "id": 1,
                            "rule": "optional"
                          },
                          "experimentName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "userToken": {
                            "type": "squareup.feature.relay.common.Token",
                            "id": 3,
                            "rule": "optional"
                          },
                          "variantName": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "variables": {
                            "type": "squareup.feature.relay.common.Variable",
                            "id": 5,
                            "rule": "repeated"
                          },
                          "isActive": {
                            "type": "bool",
                            "id": 6,
                            "rule": "optional"
                          },
                          "userAttributes": {
                            "type": "squareup.feature.relay.common.UserAttributes",
                            "id": 7,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE GetActivateExperimentRequest @ squareup/feature/relay/experiments/message/get_activate_experiment.proto at 14:1
 */
export const GetActivateExperimentRequest = $root.lookupType('squareup.feature.relay.experiments.message.GetActivateExperimentRequest');
fixType(GetActivateExperimentRequest, {
  experimentName: {
    required: true,
    notEmpty: true
  },
  userToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetActivateExperimentRequest);
/**
 * SOURCE GetActivateExperimentResponse @ squareup/feature/relay/experiments/message/get_activate_experiment.proto at 27:1
 */
export const GetActivateExperimentResponse = $root.lookupType('squareup.feature.relay.experiments.message.GetActivateExperimentResponse');
fixType(GetActivateExperimentResponse, {
  experimentName: {
    required: true,
    notEmpty: true
  },
  userToken: {
    required: true
  },
  isActive: {
    required: true
  }
});
Builder.createAndAttachToType(GetActivateExperimentResponse);